import React, { useState } from 'react';
import styled from 'styled-components';
import { dynamicSortOfObjects } from '@utils/tools/dynamicSortofObjects';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createObjectWrapper } from '@utils/miscellaneous/objectHelpers';

const StyledContainer = styled.div`
  th:first-of-type {
    width: 170px;
  }
`;

const StyledTableHeader = styled.th`
  white-space: nowrap;
`;

const TicketList = ({ propsTicketListData, userRole }) => {
    const [ticketListData, setTicketListData] = useState(propsTicketListData);
    const [isAsending, setAsending] = useState(true);

    const handleTicketButtonPress = (identifier, isDate, isNumber) => {
        const newTicketList = dynamicSortOfObjects(ticketListData, identifier, isDate, isAsending, isNumber);
        setTicketListData([...newTicketList]);
        setAsending(!isAsending);
    };

    let allSetOfHeaders = [
        {
            variableNameTitle: 'number',
            variableName: 'id',
            isDate: false,
            isNumber: true
        },
        {
            variableNameTitle: 'subject',
            variableName: 'subject',
            isDate: false,
            isNumber: false
        },
        {
            variableNameTitle: 'user',
            variableName: 'user',
            isDate: false,
            isNumber: false
        },
        {
            variableNameTitle: 'status',
            variableName: 'status',
            isDate: false,
            isNumber: false
        },
        {
            variableNameTitle: 'creationTime',
            variableName: 'creationTime',
            isDate: true,
            isNumber: false
        },
        {
            variableNameTitle: 'closed_date',
            variableName: 'closed_date',
            isDate: true,
            isNumber: false
        }
    ];
    const  arrayOfHeaders = userRole ?
        allSetOfHeaders.filter(h => h.variableName !== 'user') :
        allSetOfHeaders;

    const renderTableHeaders = ( ) => {
        return arrayOfHeaders.map(obj => {
            return (
                <StyledTableHeader scope="col" key={`ticket-titles-th-${obj.variableName}`}>
                    <button className="ticket-button--unstyled text-left" type="button" onClick={() => handleTicketButtonPress(obj.variableName,obj.isDate, obj.isNumber)}>
                        <FormattedMessage id={`ticket.table_title.${obj.variableNameTitle}`} className="table-titles"/>
                        <span className="fa-stack">
                            <FontAwesomeIcon icon='caret-up' />
                            <FontAwesomeIcon icon='caret-down' />
                        </span>
                    </button>
                </StyledTableHeader>);

        });
    };


    return (
        <StyledContainer className="text-center">
            <Table responsive className="table px-2 gi-usa-table text-left grid-col-12 table-layout-fixed">
                <thead>
                    <tr>
                        { renderTableHeaders() }
                    </tr>
                </thead>
                <tbody>
                    { createObjectWrapper(ticketListData).map(item => {
                        return ( <TicketRow key={item.id} row={item} userRole={userRole}/> ); }).valueOf()
                    }
                </tbody>
            </Table>
        </StyledContainer>
    );
};

const TicketRow = ({ row, userRole }) => {
    const { id, number, subject, user, status, creationTime, closeDate, encryptedId } = row;
    return (
        <tr key={id}>
            <td><Link to={`${encryptedId}`}>
                <FormattedMessage id="ticket.table_cell.ticket_number" values={{ ticketNumber: number }}/>
            </Link></td>
            <td><FormattedMessage id="ticket.table_cell.subject" values={{ subject }}/> </td>
            { !userRole ?
                <td><FormattedMessage id="ticket.table_cell.user" values={{ user }}/></td>
                : null}
            <td><FormattedMessage id="ticket.table_cell.status" values={{ status }}/></td>
            <td><FormattedMessage id="ticket.table_cell.creation_time" values={{ creationTime }}/></td>
            <td><FormattedMessage id="ticket.table.cell.closed_date" values={{ closeDate: closeDate ? closeDate : ' ' }}/></td>
        </tr>
    );
};

export default TicketList;